var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      staticClass: "scm-dialog",
      attrs: {
        title: _vm.title,
        visible: _vm.dialogVisible,
        width: _vm.width,
        "before-close": _vm.handelClose,
        "close-on-click-modal": false,
        "close-on-press-escape": false
      },
      on: {
        "update:visible": function($event) {
          _vm.dialogVisible = $event
        }
      }
    },
    [
      _c("div", { staticClass: "body" }, [_vm._t("default")], 2),
      _c(
        "div",
        { attrs: { slot: "footer" }, slot: "footer" },
        [
          _c(
            "el-button",
            {
              staticClass: "scm-dialog-cancel",
              attrs: { size: "small", disabled: _vm.loading },
              on: { click: _vm.handelClose }
            },
            [_vm._v("取 消")]
          ),
          _c(
            "el-button",
            {
              staticClass: "scm-dialog-submit",
              attrs: { size: "small", loading: _vm.loading, type: "primary" },
              on: { click: _vm.handelSubmit }
            },
            [_vm._v("确 定")]
          )
        ],
        1
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }